import { makeOnMessageHandler } from '../consent-sync'


/**
 * Adds a `message` event listener to the `window` object. This listener will set the
 * `TERMLY_API_CACHE` in localStorage if the received message has an `origin` that matches
 * the supplied `masterOrigin`.
 *
 * @param {String} masterOrigin - the fully-qualified origin from which we want to receive
 *    messages that contain the reference TERMLY_API_CACHE to write to the `localStorage`
 *    a subdomain.
 */
export default function initMasterConsentsOriginSync(masterOrigin) {
  window.addEventListener('message', makeOnMessageHandler(masterOrigin))
}
